<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <h2>Creazione sondaggi</h2>
    <div fxLayout="column">
      <form [formGroup]="form" fxLayout="column" class="responsive-mat-form">

        <!-- Id field -->
        <mat-form-field>
          <input matInput formControlName="id" placeholder="Sondaggio Id" readonly="true" />
        </mat-form-field>

        <!-- Creatore field -->
        <mat-form-field>
          <mat-select name="creatore" [disabled]="!isJappTenantAdmin()" [compareWith]="compareDTO"
            formControlName="creatore" placeholder="Scegli il creatore">
            <mat-option *ngFor="let collaboratore of collaboratori" readonly="true" [value]="collaboratore">
              {{collaboratore.nome}} {{collaboratore.cognome}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('creatore').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!-- Titolo sondaggio -->
        <mat-form-field fxlayout="column" >
          <mat-label>Inserisci il titolo</mat-label>
          <input matInput formControlName="titolo" placeholder="Inserisci il titolo" >
          <mat-error *ngIf="form.get('titolo').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!-- Dscrizione sondaggio -->
        <mat-form-field fxlayout="column">
          <textarea cdkTextareaAutosize matInput formControlName="descrizione" placeholder="Inserisci la descrizione"
            maxlength="4000"></textarea>
          <mat-error *ngIf="form.get('descrizione').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!-- Data scadenza  -->
        <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
          <input matInput [disabled]="bloccaModifica" readonly="true" (click)="picker2.open()" [min]="dataMin"
            [matDatepicker]="picker2" formControlName="dataScadenza"
            placeholder="Scegli data scadenza (compresa)">
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
          <button mat-button [disabled]="bloccaModifica" *ngIf="form.get('dataScadenza').value != null" matSuffix
            mat-icon-button aria-label="Clear" (click)="form.get('dataScadenza').setValue(null)">
            <mat-icon>close</mat-icon>
          </button>
          <mat-error *ngIf="form.get('dataScadenza').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>


        <!-- Opzioni -->
        <div class="option-container" fxLayout="row" fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
          <mat-form-field fxFlex="90" class="option-field">
            <input matInput formControlName="newOption" placeholder="Aggiungi un'opzione" />
          </mat-form-field>
          <button mat-icon-button (click)="addOption()" class="remove-btn" [disabled]="!this.isNewOptionValid()" class="add-btn">
            <mat-icon fxFlex="10">add_circle_outline</mat-icon>
          </button>
        </div>

        <div fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" *ngIf="getNumOptions() > 0">
          Opzioni inserite:
        </div>
        <div class="option-container" *ngIf="getNumOptions() > 0" fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
          <div fxLayout="row" *ngFor="let option of currentOptions" class="option-item">
            <mat-form-field fxFlex="90" class="option-field">
              <input matInput readonly="true" [value]="option.name" />
            </mat-form-field>
            <button mat-icon-button (click)="removeOption(option)" class="remove-btn">
              <mat-icon fxFlex="10" >remove_circle_outline</mat-icon>
            </button>
          </div>
        </div>

        <!-- Checkbox -->
        <mat-checkbox formControlName="isMultiple" (change)="isMultipleAnswer()"  *ngIf="getNumOptions() > 0" 
          [disabled]="getNumOptions() < 2" fxFlex="50" fxFlex.md="100"
          fxFlex.sm="100" fxFlex.xs="100">
          Sondaggio a risposta multipla
        </mat-checkbox>

        <ul *ngIf="isMultiple==true">
          <div fxLayout="row">
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput type="number" min="1" [max]="getNumOptions()" formControlName="numMaxRisposte"
                placeholder="inserisci il numero massimo di opzioni selezionabili">
              <mat-error *ngIf="form.get('numMaxRisposte').errors?.required">
                Campo obbligatorio
              </mat-error>
            </mat-form-field>
          </div>
        </ul>

        <br>
        <!-- Create / Delete / Back -->
        <mat-card-actions>
          <button mat-raised-button (click)="backConfirm(previousUrl)" color="primary">Back</button>
          <button mat-raised-button (click)="save()" [disabled]="!isFormValid() || !form.dirty"
            *ngIf="sondaggio?.deleteDate==null">Save</button>
          <button mat-raised-button (click)="delete()" [disabled]="sondaggio?.id==null"
            *ngIf="sondaggio?.deleteDate==null">Delete</button>
        </mat-card-actions>

        <!-- Campi di informazione operazione -->
        <mat-expansion-panel class="mat-elevation-z0">

          <mat-expansion-panel-header>
            <mat-panel-title>
              Dettagli operazione
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="row">

            <!-- InsertDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="dataScadenza" placeholder="Insert Date" readonly="true" />
            </mat-form-field>

            <!-- InsertUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="insertUser" placeholder="Insert User" readonly="true" />
            </mat-form-field>
          </div>
          <div fxLayout="row">

            <!-- UpdateDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="updateDate" placeholder="Update Date" readonly="true" />
            </mat-form-field>

            <!-- UpdateUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="updateUser" placeholder="Update User" readonly="true" />
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
  </mat-card-content>
</mat-card>